import React, { Component, Fragment } from "react";
import { Router, Redirect, Switch, StaticRouter} from "react-router-dom";
import { connect } from "react-redux";
import LayoutRoute from "./components/LayoutRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import "video-react/dist/video-react.css";
import history from "./imports/history";
import routes from "./routes";
import * as moment from "moment-jalaali";
import { canUseDOM } from "exenv";
import "moment/min/locales.min.js";
import { Helmet } from "react-helmet";
import { ajaxJson } from "./imports/ajax";
import * as auth from "./imports/auth";
import { map2UserObj } from "./imports/mapper";
import * as Sentry from '@sentry/react';
import Modal from 'react-modal';
import ReactGA from "react-ga4";

setTimeout(()=>{
    ReactGA.initialize("G-BMBHSQ1K8J");
    console.log("page :",window.location.pathname + window.location.search);
    console.log("title :",document.title);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: document.title });
},3000)


moment.loadPersian({
    usePersianDigits: true,
    dialect: "persian-modern"
});

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        padding:0
    }
};

function FallbackComponent() {
    return (
        <div>An error has occured</div>
    )
}

function Head() {
    return (
        <Helmet>
            <title>آکادمی درایت</title>
            {/* {process.env.REACT_APP_USE_ANALYTIC && (
                <script
                    type="text/javascript"
                    async
                    src="https://www.googletagmanager.com/gtag/js?id=UA-136306138-1"
                ></script>
            )}

            {process.env.REACT_APP_USE_ANALYTIC && (
                <script type="text/javascript">{`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments)}
              gtag('js', new Date());
              gtag('config', 'UA-136306138-1');
            `}</script>
            )} */}

            {/*{*/}
            {/*    <script type="text/javascript">{`!function(){function t(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,localStorage.getItem("rayToken")?t.src="https://app.raychat.io/scripts/js/"+o+"?rid="+localStorage.getItem("rayToken")+"&href="+window.location.href:t.src="https://app.raychat.io/scripts/js/"+o;var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e)}var e=document,a=window,o="324bdaac-8822-4b96-984a-23a14e96cd3a";"complete"==e.readyState?t():a.attachEvent?a.attachEvent("onload",t):a.addEventListener("load",t,!1)}();`}</script>*/}
            {/*}*/}

            {/* {
                <script>
                    {` (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:1434412,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
                </script>
            } */}

            {/*{*/}
            {/*    <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':*/}
            {/*    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],*/}
            {/*    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=*/}
            {/*    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);*/}
            {/*    })(window,document,'script','dataLayer','GTM-WCQJ9WR');`}</script>*/}


            {/*}*/}
        </Helmet>
    );
}

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalIsOpen:true,
        };
    }

    componentDidMount() {
        const loadingElement = window.document.getElementById("loading");
        this.getStaticData().then(() => {
            if (loadingElement && loadingElement.remove) {
                setTimeout(() => {
                    loadingElement.remove();
                }, 800);
            }
        });
        if (auth.isLogin()) {
            this.getUser();
        }


        this.unlisten = history.listen((location, action) => {
            setTimeout(() => {
                console.log("page :",window.location.pathname + window.location.search);
                console.log("title :",document.title);
                ReactGA.initialize("G-BMBHSQ1K8J");
                ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: document.title });
            },3000)
        });


        // ReactGA.initialize('UA-274761737-1', {
        //     debug: false,
        //     titleCase: false,
        // });
        // ReactGA.pageview(window.location.pathname + window.location.search);


    }

    componentWillUnmount() {
        this.unlisten();
    }

    getUser() {
        ajaxJson
            .get("/users")
            .then(res => {
                const userObj = map2UserObj(res.data);
                return [userObj, res.data["access_token"]];
            })
            .then(([user, token]) => {
                if (user && user["access_token"]) {
                    auth.login({
                        token,
                        ...user
                    });
                }
            });
    }

    getStaticData() {
        return ajaxJson.get(`/front/site_detail`).then(res => {
            this.props.setStaticData(res.data);
        });
    }

    makeRoutsComponents() {
        return routes.map((route, index) => {
            let props = {
                key: index,
                exact: route.exact,
                path: route.path,
                layout: route.layout,
                component: route.component,
                protectors: route.protectors || []
            };
            return <LayoutRoute {...props} />;
        });
    }

    closeModal(){
        this.setState({modalIsOpen:false})
    }

    goToAmirkabir(){
        window.location.href="https://amirkabir.derayat.org/home"
    }

    render() {
        if (canUseDOM) {
            return (
                <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
                    {/*<Modal*/}
                    {/*    isOpen={this.state.modalIsOpen}*/}
                    {/*    onRequestClose={this.closeModal.bind(this)}*/}
                    {/*    style={customStyles}*/}
                    {/*>*/}
                    {/*    <div className="course-main-message">*/}
                    {/*        <div className="ribbon">*/}

                    {/*        </div>*/}
                    {/*        <div className="course-main-message-body">*/}
                    {/*            <span>                                 برای  ثبت‌نام در</span>*/}
                    {/*            <span className="course-main-message-bold" onClick={this.goToAmirkabir}>دوره MBA  آنلاین دانشگاه صنعتی امیرکبیر</span>*/}
                    {/*            <span>و کسب اطلاعات بیشتر به اینجا مراجعه کنید</span>*/}
                    {/*            </div>*/}
                    {/*        <span className="course-main-message-btn" onClick={this.goToAmirkabir}>اطلاعات بیشتر</span>*/}
                    {/*    </div>*/}
                    {/*</Modal>*/}
                <Fragment>
                    <Head />
                    <Router history={history}>
                        <Switch>
                            {this.makeRoutsComponents()}
                            <Redirect to="/" />
                        </Switch>
                    </Router>
                    <ToastContainer position={"bottom-left"} hideProgressBar />
                </Fragment>
                </Sentry.ErrorBoundary>
            );
        } else {
            const context = {};
            const { url } = this.props;
            return (
                <Sentry.ErrorBoundary fallback={FallbackComponent} showDialog>
                <Fragment>
                    <Head />
                    <StaticRouter location={url} context={context}>
                        <Switch>
                            {this.makeRoutsComponents()}
                            <Redirect to="/" />
                        </Switch>
                    </StaticRouter>
                    <ToastContainer position={"bottom-left"} hideProgressBar />
                </Fragment>
                </Sentry.ErrorBoundary>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return { ...ownProps };
};

const mapDispatchToProps = dispatch => ({
    setStaticData: data => {
        dispatch({
            type: "setStaticData",
            payload: data
        });
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// 388613946
